import { Box, styled, useTheme } from "@mui/material";

import { CloudFlowJsonFormatter } from "../../CloudflowBuilder/Common/CloudFlowJsonFormatter";
import { type TabConfig, type TabId } from "./types";

const StyledPre = styled("pre")(({ theme }) => ({
  height: 400,
  overflow: "auto",
  overflowX: "auto",
  whiteSpace: "pre",
  margin: 0,
  marginTop: theme.spacing(2),
  borderTopLeftRadius: 0,
  borderTopRightRadius: 0,
  borderBottomLeftRadius: theme.shape.borderRadius,
  borderBottomRightRadius: theme.shape.borderRadius,
  color: theme.palette.text.primary,
}));

type TabPanelProps = {
  tabConfig: TabConfig[];
  activeTab: TabId;
};

const TabPanel = ({ tabConfig, activeTab }: TabPanelProps) => {
  const theme = useTheme();

  const activeConfig = tabConfig.find((config) => config.id === activeTab);

  if (!activeConfig?.show) {
    return null;
  }

  return (
    <Box sx={{ marginBottom: theme.spacing(2) }}>
      <StyledPre>{activeConfig.data && <CloudFlowJsonFormatter jsonObj={activeConfig.data} />}</StyledPre>
    </Box>
  );
};

export default TabPanel;
